import { FC } from 'react';
import { UnifiedProfilesListTab } from './components';
import { UnifiedProfilesProvider } from './context';

export const UnifiedProfiles: FC = () => {
  return (
    <>
      <UnifiedProfilesProvider>
        <UnifiedProfilesListTab />
      </UnifiedProfilesProvider>
    </>
  );
};
